import {CHANGE_LOCALE} from './constants';

export function changeLocale(languageLocale: string) {
    return (dispatch: (arg0: {type: string; locale?: string}) => void) => {
        dispatch({type: CHANGE_LOCALE, locale: languageLocale});
    };
}
